<script setup lang="ts">
import PartnersMultiSportForm from '@/domains/partners/multisport/components/Form/Form.vue'
</script>

<template>
  <section class="productPartnersPage">
    <PartnersMultiSportForm />
  </section>
</template>

<style lang="scss" scoped>
.productPartnersPage {
  padding-top: 7.4rem;
}

</style>
